<template>
	<!--?xml version="1.0" encoding="UTF-8"?-->
	<!-- eslint-disable -->
	<svg
		viewBox="0 0 227 46"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
    :class="{ active }">
		<title>Logo Armado</title>
		<g
			id="LogoArmado"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd">
			<g
				id="armado"
				stroke-width="0.5">
				<path
					id="Fill-1"
					d="M27.684,44.817 C26.022,44.817 24.67,43.464 24.67,41.803 L24.67,29.493 C24.67,28.182 24.422,26.933 23.934,25.781 C23.447,24.64 22.769,23.63 21.917,22.775 C21.071,21.928 20.07,21.25 18.942,20.76 C17.814,20.272 16.597,20.023 15.324,20.023 C14.048,20.023 12.83,20.272 11.705,20.76 C10.58,21.248 9.58,21.926 8.731,22.775 C7.882,23.624 7.204,24.635 6.714,25.781 C6.226,26.93 5.977,28.179 5.977,29.493 C5.977,30.768 6.226,31.986 6.714,33.112 C7.202,34.237 7.881,35.238 8.731,36.088 C9.58,36.937 10.58,37.615 11.705,38.102 C12.83,38.591 14.048,38.839 15.324,38.839 C15.751,38.839 16.148,38.817 16.505,38.774 C16.79,38.742 17.081,38.695 17.379,38.635 L18.755,44.422 C18.254,44.498 17.73,44.577 17.183,44.665 C16.555,44.765 15.929,44.817 15.324,44.817 C13.207,44.817 11.198,44.405 9.35,43.592 C7.501,42.781 5.86,41.667 4.474,40.281 C3.094,38.902 1.99,37.263 1.195,35.406 C0.402,33.555 -4.4408921e-14,31.566 -4.4408921e-14,29.493 C-4.4408921e-14,27.381 0.402,25.37 1.195,23.517 C1.99,21.665 3.094,20.024 4.474,18.643 C5.858,17.26 7.498,16.157 9.348,15.363 C11.199,14.571 13.21,14.17 15.324,14.17 C17.437,14.17 19.449,14.571 21.3,15.364 C23.151,16.159 24.79,17.262 26.174,18.643 C27.555,20.026 28.658,21.666 29.454,23.517 C30.246,25.37 30.648,27.381 30.648,29.493 L30.648,41.853 C30.648,43.487 29.319,44.817 27.684,44.817"
					stroke="#808285"
					fill="#808285"
					class="svg-elem-1"/>
				<path
					id="Fill-4"
					d="M41.561,44.817 C39.881,44.817 38.515,43.451 38.515,41.771 L38.515,29.493 C38.473,27.421 38.854,25.433 39.645,23.58 C40.442,21.727 41.545,20.088 42.925,18.706 C44.312,17.322 45.963,16.209 47.832,15.394 C49.628,14.614 51.562,14.203 53.589,14.171 L53.589,20.151 C52.41,20.181 51.277,20.427 50.219,20.884 C49.095,21.372 48.097,22.039 47.247,22.866 C46.396,23.696 45.717,24.699 45.229,25.844 C44.741,26.993 44.493,28.221 44.493,29.493 L44.493,41.885 C44.493,43.502 43.178,44.817 41.561,44.817"
					stroke="#808285"
					fill="#808285"
					class="svg-elem-2"/>
				<path
					id="Fill-11"
					d="M109.1464,44.2711 L109.1464,28.9481 C109.1464,27.6751 108.8984,26.4481 108.4104,25.3001 C107.9224,24.1541 107.2434,23.1511 106.3924,22.3211 C105.5404,21.4921 104.5414,20.8251 103.4214,20.3391 C102.2884,19.8501 101.0694,19.6021 99.8024,19.6021 C98.5334,19.6021 97.3144,19.8501 96.1824,20.3391 C95.0554,20.8281 94.0564,21.4951 93.2104,22.3211 C92.3594,23.1511 91.6814,24.1541 91.1924,25.3001 C90.7054,26.4481 90.4564,27.6751 90.4564,28.9481 L90.4564,41.5051 C90.4564,43.0301 89.2154,44.2711 87.6894,44.2711 L87.2134,44.2711 C85.7054,44.2711 84.4794,43.0441 84.4794,41.5371 L84.4794,38.0801 L84.4654,38.0801 L84.4654,28.9481 C84.4654,27.6751 84.2174,26.4481 83.7294,25.3001 C83.2414,24.1521 82.5614,23.1501 81.7104,22.3201 C80.8604,21.4921 79.8614,20.8261 78.7404,20.3391 C77.6064,19.8501 76.3894,19.6021 75.1224,19.6021 C73.8544,19.6021 72.6344,19.8501 71.5014,20.3391 C70.3754,20.8281 69.3764,21.4951 68.5294,22.3211 C67.6794,23.1511 67.0004,24.1541 66.5124,25.3001 C66.0234,26.4451 65.7764,27.6731 65.7764,28.9481 L65.7764,41.5051 C65.7764,43.0301 64.5344,44.2711 63.0094,44.2711 L62.5334,44.2711 C61.0254,44.2711 59.7984,43.0441 59.7984,41.5371 L59.7984,28.9481 C59.7554,26.8741 60.1374,24.8851 60.9294,23.0351 C61.7244,21.1811 62.8284,19.5421 64.2084,18.1621 C65.5954,16.7771 67.2464,15.6631 69.1154,14.8501 C70.9834,14.0371 73.0044,13.6241 75.1224,13.6241 C77.2384,13.6241 79.2574,14.0371 81.1254,14.8491 C82.9964,15.6631 84.6464,16.7781 86.0324,18.1621 C86.4074,18.5361 86.7374,18.9681 87.0564,19.3861 L87.4604,19.9121 L87.8704,19.3801 C88.1884,18.9641 88.5164,18.5341 88.8894,18.1621 C90.2754,16.7771 91.9274,15.6631 93.7964,14.8501 C95.6654,14.0371 97.6844,13.6241 99.8024,13.6241 C101.9184,13.6241 103.9384,14.0371 105.8064,14.8491 C107.6754,15.6631 109.3274,16.7771 110.7144,18.1621 C112.1004,19.5491 113.2034,21.1901 113.9934,23.0351 C114.7854,24.8811 115.1664,26.8681 115.1254,28.9431 L115.1254,44.2711 L109.1464,44.2711 Z"
					stroke="#808285"
					fill="#808285"
					class="svg-elem-3"/>
				<path
					id="Fill-6"
					d="M148.9892,44.817 C147.2552,44.817 145.8442,43.406 145.8442,41.672 L145.8442,29.493 C145.8442,28.184 145.5952,26.935 145.1072,25.781 C144.6212,24.64 143.9432,23.629 143.0932,22.775 C142.2442,21.928 141.2422,21.25 140.1162,20.76 C138.9882,20.272 137.7702,20.023 136.4982,20.023 C135.2232,20.023 134.0052,20.272 132.8792,20.76 C131.7542,21.248 130.7532,21.927 129.9052,22.775 C129.0542,23.626 128.3772,24.637 127.8882,25.781 C127.3992,26.929 127.1522,28.177 127.1522,29.493 C127.1522,30.769 127.4002,31.986 127.8882,33.112 C128.3752,34.234 129.0532,35.235 129.9052,36.087 C130.7532,36.936 131.7542,37.614 132.8792,38.102 C134.0062,38.592 135.2232,38.839 136.4982,38.839 C136.9282,38.839 137.3252,38.817 137.6802,38.774 C137.9642,38.742 138.2552,38.695 138.5522,38.634 L139.9282,44.422 C139.4282,44.497 138.9032,44.577 138.3572,44.665 C137.7312,44.765 137.1042,44.817 136.4982,44.817 C134.3822,44.817 132.3722,44.406 130.5242,43.592 C128.6762,42.782 127.0342,41.667 125.6482,40.281 C124.2682,38.903 123.1662,37.263 122.3682,35.407 C121.5762,33.557 121.1752,31.568 121.1752,29.493 C121.1752,27.38 121.5762,25.369 122.3682,23.517 C123.1662,21.662 124.2682,20.023 125.6482,18.643 C127.0312,17.261 128.6722,16.157 130.5222,15.363 C132.3742,14.571 134.3852,14.17 136.4982,14.17 C138.6112,14.17 140.6222,14.571 142.4732,15.364 C144.3262,16.16 145.9662,17.263 147.3482,18.643 C148.7302,20.027 149.8332,21.667 150.6282,23.517 C151.4202,25.369 151.8222,27.379 151.8222,29.493 L151.8222,41.984 C151.8222,43.546 150.5512,44.817 148.9892,44.817"
					stroke="#808285"
					fill="#808285"
					class="svg-elem-4"/>
				<path
					id="Fill-8"
					d="M173.1914,44.817 C171.0794,44.817 169.0684,44.416 167.2164,43.623 C165.3624,42.829 163.7224,41.725 162.3414,40.343 C160.9614,38.963 159.8574,37.324 159.0614,35.47 C158.2694,33.617 157.8684,31.607 157.8684,29.493 L157.8684,28.559 C157.8684,28.285 157.9074,27.992 157.9844,27.687 C158.1934,25.782 158.7394,23.999 159.6134,22.354 C160.4904,20.704 161.6254,19.25 162.9874,18.03 C164.3484,16.811 165.9164,15.84 167.6464,15.148 C169.3774,14.457 171.2414,14.107 173.1914,14.107 C173.8244,14.107 174.4714,14.157 175.1154,14.258 C175.6584,14.347 176.1834,14.429 176.6834,14.502 L175.3084,20.294 C174.9754,20.233 174.6644,20.185 174.3734,20.15 C174.0134,20.108 173.6164,20.087 173.1914,20.087 C171.9164,20.087 170.6994,20.334 169.5734,20.823 C168.4504,21.31 167.4494,21.988 166.5974,22.838 C165.7474,23.69 165.0694,24.701 164.5824,25.844 C164.0934,26.993 163.8454,28.221 163.8454,29.493 C163.8454,30.768 164.0934,31.985 164.5834,33.112 C165.0704,34.236 165.7484,35.237 166.5974,36.087 C167.4484,36.937 168.4494,37.615 169.5734,38.102 C170.6994,38.592 171.9174,38.839 173.1914,38.839 C174.4634,38.839 175.6924,38.592 176.8404,38.102 C177.9854,37.616 178.9964,36.938 179.8464,36.087 C180.6964,35.235 181.3764,34.234 181.8624,33.112 C182.3494,31.986 182.5974,30.769 182.5974,29.493 L182.5974,7.10542736e-15 L188.5794,5.863 L188.5794,29.493 C188.5794,31.607 188.1764,33.617 187.3824,35.47 C186.5904,37.318 185.4884,38.959 184.1034,40.343 C182.7224,41.725 181.0714,42.827 179.1984,43.623 C177.3254,44.416 175.3034,44.817 173.1914,44.817"
					stroke="#808285"
					fill="#808285"
					class="svg-elem-5"/>
				<path
					id="Fill-13"
					d="M226.83,29.8267 C226.83,38.3667 219.906,45.2907 211.366,45.2907 C202.825,45.2907 195.901,38.3667 195.901,29.8267 C195.901,21.2857 202.825,14.3617 211.366,14.3617 C219.906,14.3617 226.83,21.2857 226.83,29.8267"
					stroke="#2BB9A6"
					fill="#2BB9A6"
					class="svg-elem-6"/>
			</g>
		</g>
	</svg>
</template>

<script setup lang="ts">
defineProps({ active: Boolean });
</script>

<style scoped>
/***************************************************
 * Generated by SVG Artista on 12/10/2019, 11:15:29 AM
 * MIT license (https://opensource.org/licenses/MIT)
 * W. https://svgartista.net
 **************************************************/

svg .svg-elem-1 {
  stroke-dashoffset: 164.01473999023438px;
  stroke-dasharray: 164.01473999023438px;
  fill: transparent;
	transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0s, fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 0.8s;
}

svg.active .svg-elem-1 {
  stroke-dashoffset: 0;
  fill: rgb(128, 130, 133);
}

svg .svg-elem-2 {
  stroke-dashoffset: 80.3254623413086px;
  stroke-dasharray: 80.3254623413086px;
  fill: transparent;
	transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.12s, fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 0.9s;
}

svg.active .svg-elem-2 {
  stroke-dashoffset: 0;
  fill: rgb(128, 130, 133);
}

svg .svg-elem-3 {
  stroke-dashoffset: 242.86636352539062px;
  stroke-dasharray: 242.86636352539062px;
  fill: transparent;
	transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.24s, fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1s;
}

svg.active .svg-elem-3 {
  stroke-dashoffset: 0;
  fill: rgb(128, 130, 133);
}

svg .svg-elem-4 {
  stroke-dashoffset: 164.0135498046875px;
  stroke-dasharray: 164.0135498046875px;
  fill: transparent;
	transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.36s, fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.1s;
}

svg.active .svg-elem-4 {
  stroke-dashoffset: 0;
  fill: rgb(128, 130, 133);
}

svg .svg-elem-5 {
  stroke-dashoffset: 191.58155822753906px;
  stroke-dasharray: 191.58155822753906px;
  fill: transparent;
  transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.48s, fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.2000000000000002s;
}

svg.active .svg-elem-5 {
  stroke-dashoffset: 0;
  fill: rgb(128, 130, 133);
}

svg .svg-elem-6 {
  stroke-dashoffset: 99.1795654296875px;
  stroke-dasharray: 99.1795654296875px;
  fill: transparent;
  transition: stroke-dashoffset 1s cubic-bezier(0.47, 0, 0.745, 0.715) 0.6s, fill 0.7s cubic-bezier(0.47, 0, 0.745, 0.715) 1.3s;
}

svg.active .svg-elem-6 {
  stroke-dashoffset: 0;
  fill: rgb(43, 185, 166);
}
</style>
